/* ============================================================================
   设计台「素材库」模块 —— 自 sections/design-canvas.liquid 外置（2026-10-12）
   为什么外置：section 已贴 256KB 资产顶（262013 B，仅剩 131 B 空间）。
   依赖由 section 注入 `window.__hdLibDeps = { b, toast, add, load }`：
     b     = bridge 基址（原 `B`）
     toast = showToast
     add   = addImage
     load  = hdcoLoad
   🔴 下面这 5 行是「依赖桥」—— 4 个同名包装让 IIFE 内部**原有代码逐字不变**（零回归）。
      取值一律延迟到调用时（不缓存），避免脚本执行顺序带来的空引用。
   ============================================================================ */
window.__hdLib=(function(){
  var B=(window.__hdLibDeps&&window.__hdLibDeps.b)||'https://bridge.highdeep.net';
  function showToast(m,t){ var f=(window.__hdLibDeps||{}).toast; if(f){ try{ f(m,t); }catch(e){} } }
  function addImage(u,o){ var f=(window.__hdLibDeps||{}).add; if(f){ return f(u,o); } }
  function hdcoLoad(){ var f=(window.__hdLibDeps||{}).load; if(f){ try{ return f(); }catch(e){} } return null; }
  /* 2026-10-12（用户裁决）：前端**不再主动压缩** —— 原图直传，压缩交给后端 sharp。
   只留一条**极端护栏** GUARD_BYTES：本地文件超过它才降采样，否则 base64 会比原图再涨 33%，
   撑爆 nginx/express 的 50MB 请求体上限（连请求都发不出去）。原 LIMIT/TARGET 已废弃。 */
var GUARD_BYTES=24*1024*1024, MAXEDGE=2000;
  var loaded=false, loading=false, mine=[], ours=[];

  function el(id){ return document.getElementById(id); }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); }
  function msg(t){ var n=el('pfmLibMsg'); if(n) n.textContent=t||''; }
  /* 身份 = 进站弹窗收集的邮箱 + 昵称（与 Save/My Designs 同一份本地档案） */
  function ident(){
    var p=null; try{ p=hdcoLoad(); }catch(e){}
    return { email:(p&&p.email)||'', nick:(p&&p.nick)||'' };
  }
  /* 2026-10-09（甲 · 用户裁决）：长按 600ms 删除**自己上传**的素材。
     只有 mine 段（src='user'）传 own=true 才绑长按；官方 Library 长按无反应。
     未到 600ms 松手 / 移动超 8px ⇒ 取消，照常走 click 插图（老行为零回归）。
     到点 ⇒ 卡片浮起 + 右上角露出 ✕。收枪三路：点别处 / pointercancel / 闲置 8s
     （与项目「浮层自动收起」同口径，且不与功能态冲突 —— 这里没有功能态）。
     为什么 ✕ 做小并贴角：面板窄（420~560px）、5 列每格约 60px，
     中央大按钮会整块盖住缩略图 ⇒ 反而看不清删的是哪张。 */
  var PRESS_MS=600, _armed=null, _idle=0;
  function disarm(){
    if(_idle){ clearTimeout(_idle); _idle=0; }
    if(!_armed) return;
    var x=_armed.querySelector('.pfm-lib-x'); if(x) x.remove();
    _armed.classList.remove('pfm-armed');
    _armed.style.opacity='';
    _armed=null;
  }
  function arm(d,o){
    if(_armed===d) return;
    disarm();
    _armed=d; d.classList.add('pfm-armed');
    var x=document.createElement('button');
    x.type='button'; x.className='pfm-lib-x';
    x.title='Delete'; x.setAttribute('aria-label','Delete this image');
    x.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>';
    x.addEventListener('pointerdown',function(e){ e.stopPropagation(); });
    x.addEventListener('click',function(e){ e.stopPropagation(); e.preventDefault(); drop(d,o); });
    d.appendChild(x);
    _idle=setTimeout(disarm,8000);
  }
  function drop(d,o){
    var id=ident();
    if(!id.email||!o.id) return;
    d.style.opacity='.4';
    fetch(B+'/assets/lib/delete',{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({email:id.email,nickname:id.nick,id:parseInt(o.id,10)||0})})
      .then(function(r){ return r.json().then(function(dd){ return {ok:r.ok,dd:dd}; }); })
      .then(function(r){
        if(!r.ok||!r.dd||!r.dd.success) throw new Error((r.dd&&r.dd.error)||'delete failed');
        disarm();
        mine=mine.filter(function(it){ return String(it.id)!==String(o.id); });
        paint();
        try{ showToast('Removed from My Images'); }catch(_){}
      }).catch(function(e){
        disarm();
        try{ showToast('⚠️ Could not remove'+((e&&e.message)?(' — '+e.message):''),'warn'); }catch(_){}
      });
  }
  /* 全局收枪：🔴 一律用 composedPath（e.target 可能已脱链 ⇒ closest 恒 null） */
  document.addEventListener('pointerdown',function(e){
    if(!_armed) return;
    var path=(e.composedPath?e.composedPath():[]);
    if(path.indexOf(_armed)>=0) return;
    disarm();
  },true);
  function tile(o,own){
    var d=document.createElement('div');
    /* 2026-10-12：上传乐观占位态（本地预览先显，服务器确认后换真图）—— 见 ingest()。 */
    d.className='pfm-lib-item'+(o._pending?' pfm-pending':'');
    if(o._pending) d.title='Uploading…';
    else if(o.w&&o.h) d.title=o.w+'×'+o.h;
    /* 2026-10-12（乙）：有 tiny（22px 内联 base64）就先显它 —— 0 请求、立刻可见；
       清晰图（160px）load 完成后再换 src（无闪烁）。没 tiny（旧图/老浏览器）保持原行为。 */
    var _full=o.thumb||o.url, _init=(o.tiny||_full);
    d.innerHTML='<img'+(o.tiny?'':' loading="lazy"')+' alt="" src="'+esc(_init)+'">';
    if(o.tiny && _full){
      var _pre=new Image();
      _pre.onload=function(){ var _t=d.querySelector('img'); if(_t) _t.src=_full; };
      _pre.src=_full;
    }
    var t=0, sx=0, sy=0, fired=false, busy=false;
    d.addEventListener('click',function(){
      if(fired){ fired=false; return; }   /* 长按已触发 ⇒ 这次松手不插图 */
      if(!o.url||busy) return;            /* 丙：加载中不重复接单（根治连点插多张） */
      busy=true;
      /* 甲：150ms 后才转圈（图快就不闪）；图下载完 / 失败即收。
         guard 兜底：万一回调没来（极端异常），15s 后也解锁，绝不永久卡死该格。 */
      var spin=setTimeout(function(){ d.classList.add('pfm-loading'); },150);
      var guard=setTimeout(function(){ settle(); },15000);
      function settle(){ if(spin){clearTimeout(spin);spin=0;} if(guard){clearTimeout(guard);guard=0;} d.classList.remove('pfm-loading'); busy=false; }
      /* 2026-10-22：重新启用预览档（画布 1200px 快 + 导出换原图生产）；原 10-19 弃用 —— 直接用 2000px 原图上画布。
         原来「显示 1200px 预览、导出换回原图」的两套尺寸机制引发连续 bug
         （换图 scale 错位 / 加载竞态缺面 / fabric 复活 width 语义致放大溢出），
         现在画布/导出/出图全部同源，无需换图、无需 scale 补偿。 */
      addImage(o.url+'?w=1200',{origUrl:o.url, origW:o.w, origH:o.h, noSelect:true, onLoad:settle, onError:function(){
        settle(); try{ showToast('\u26a0\ufe0f Could not load this image','warn'); }catch(_){}
      }});
    });
    if(own){
      d.addEventListener('contextmenu',function(e){ e.preventDefault(); });  /* 触屏长按别弹系统菜单 */
      d.addEventListener('pointerdown',function(e){
        if(e.pointerType==='mouse'&&e.button!==0) return;
        sx=e.clientX; sy=e.clientY; fired=false;
        if(t) clearTimeout(t);
        t=setTimeout(function(){ t=0; fired=true; arm(d,o); },PRESS_MS);
      });
      d.addEventListener('pointermove',function(e){
        if(!t) return;
        if(Math.abs(e.clientX-sx)>8||Math.abs(e.clientY-sy)>8){ clearTimeout(t); t=0; }
      });
      ['pointerup','pointercancel','pointerleave'].forEach(function(ev){
        d.addEventListener(ev,function(){ if(t){ clearTimeout(t); t=0; } });
      });
    }
    return d;
  }
  /* 2026-10-09（用户裁决 丙①）：上传入口 = 素材网格首位的「+ 号空白格」
     （原「📤 Click or drop image here」大虚线框已删）。
     它必须**恒在首位**，且所在的 My Images 段也必须常驻 —— 否则空库时整段 display:none
     ⇒ 上传入口消失（铁律：看不见的功能 = 不存在的功能）。见下方 paint()。 */
  function addTile(){
    var d=document.createElement('div');
    d.className='pfm-lib-add';
    d.title='Upload an image';
    d.setAttribute('role','button');
    d.setAttribute('tabindex','0');
    d.setAttribute('aria-label','Upload an image');
    d.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true">'
      +'<path d="M12 5v14M5 12h14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
    function pick(){ var fi=el('pfmFileInput'); if(fi) fi.click(); }
    d.addEventListener('click',pick);
    d.addEventListener('keydown',function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); pick(); } });
    return d;
  }
  /* ===== 2026-10-12（甲 · 用户裁决）：**单网格** + 分批渲染 =====
     🔴 二次合并：原「My Images / Library」两段已合成**一个网格**，顺序恒为
        [+ 号] → [个人素材（own=true，可长按删）] → [官方素材]。
     分批只作用于**官方素材**（181 张是请求大头；个人素材通常 1~5 张，全量直出）：
     旧实现全量 append ⇒ 181 个 <img> ⇒ **155 次跨洋缩略图请求**（实测中位 4.4s、偶发 502）。
     🔴 无 IntersectionObserver 的老浏览器 ⇒ 退回「全量」（= 改前行为，零回归）。 */
  var BATCH = 20;
  function fill(grid, mineList, oursList){
    grid.innerHTML = '';
    grid.appendChild(addTile());               /* + 号（上传入口）恒在**整库第一位** */
    /* pending（乐观占位）格**不绑长按删除** —— 服务器上还不存在，删了会失败/报错。 */
    for (var k = 0; k < mineList.length; k++) {
      var _po = mineList[k];
      var _t = tile(_po, !(_po._pending || _po._local));   /* 占位/纯本地格不可长按删 */
      /* 2026-10-12（用户裁决）：设计师**自己上传**的图加**右下角人形小徽章**，与官方素材区分
         （官方不标 = 默认态）。格子上的 ::before/::after 已被「转圈」占用 ⇒ 徽章用真实元素；
         pointer-events:none 由 CSS 给 ⇒ 不拦点击（点格子仍能插图）。 */
      var _bd = document.createElement('i');
      _bd.className = 'pfm-mine-badge';
      _bd.setAttribute('aria-hidden', 'true');
      _t.appendChild(_bd);
      grid.appendChild(_t);
    }
    if (!oursList.length) return;
    if (!('IntersectionObserver' in window)) {
      for (var j = 0; j < oursList.length; j++) grid.appendChild(tile(oursList[j], false));
      return;
    }
    var i = 0, done = false;
    var sent = document.createElement('div');
    sent.className = 'pfm-lib-sentinel';
    /* 2026-10-12（甲 · 用户裁决）：修「只显 20 个、怎么滚都不出新的」。
       🔴 根因：IntersectionObserver **只在相交状态变化时**回调；首批 20 格（5 列 × 4 行 ≈ 264px）
         填不满网格视口（.pfm-lib-grid 桌面 max-height 560px，填满档更高）⇒ 铺完哨兵**仍在视口内**
         ⇒ isIntersecting 恒 true、无状态变化 ⇒ **再无回调** ⇒ 永久停在 20 个。
         （rootMargin 240px 让哨兵更难离开视口，进一步加剧。）
       ⇒ 正解：铺完**主动续批**（pump：只要哨兵还在视口内就再来一批），直到哨兵移出或加载完。
       root = 最近的**可滚动祖先**（从 grid 自身起找；CSS 日后改 overflow 也不失效；都没有 ⇒ null=视口兜底）。 */
    var root = null;
    try {
      /* 2026-10-13（甲 · 修复回归）：root 必须从 **父级** 起找，不能从 grid 自身起 ——
         grid 会被内容撑高（实测 4008px），拿它当 root ⇒ 哨兵恒在其「视口」内 ⇒ nearView() 恒 true
         ⇒ 续批停不下来 ⇒ 一次把 181 张全铺（#pfmLib 4029px）⇒ 撑爆右栏、把 Effects 面板顶出可视区。 */
      for (var _r = grid.parentNode; _r && _r !== document.body && _r !== document.documentElement; _r = _r.parentNode) {
        var _ov = '';
        try { _ov = getComputedStyle(_r).overflowY || ''; } catch (e) {}
        if (_ov === 'auto' || _ov === 'scroll') { root = _r; break; }
      }
    } catch (e) {}
    function nearView(){
      try {
        var r = sent.getBoundingClientRect();
        if (root) return r.top < root.getBoundingClientRect().bottom + 40;
        return r.top < (window.innerHeight || document.documentElement.clientHeight || 0) + 40;
      } catch (e) { return false; }
    }
    function more(){
      if (done) return;
      var end = Math.min(i + BATCH, oursList.length);
      for (; i < end; i++) grid.insertBefore(tile(oursList[i], false), sent);
      if (i >= oursList.length) {
        done = true;
        try { io.disconnect(); } catch (e) {}
        if (sent.parentNode) sent.parentNode.removeChild(sent);
      }
    }
    /* 计数徽章：分批态下显「Showing N / total」；全部加载完 ⇒ 只显总数。
       setTimeout 0：fill() 由 paint() 调用，晚一步可避免被 paint 的「总数」赋值覆盖。 */
    function cnt(){
      setTimeout(function () {
        try {
          var c = el('pfmLibOursCnt'); if (!c) return;
          var total = mineList.length + oursList.length;
          var shown = mineList.length + (i < oursList.length ? i : oursList.length);
          c.textContent = (shown >= total) ? String(total) : ('Showing ' + shown + ' / ' + total);
        } catch (e) {}
      }, 0);
    }
    function pump(){
      if (done) return;
      more();
      cnt();
      if (!done && nearView()) setTimeout(pump, 16);
    }
    var io = new IntersectionObserver(function (es) {
      if (es[0] && es[0].isIntersecting) pump();
    }, { root: root, rootMargin: '240px 0px' });
    /* 兜底：个别浏览器/嵌套滚动场景 IO 不报 ⇒ 滚动时再判一次。
       ⚠️ 每次 fill 都要重新绑定前先卸掉旧的（否则刷新素材库会堆积监听器）。 */
    try { if (grid._pfmScr) { grid._pfmScrRoot && grid._pfmScrRoot.removeEventListener('scroll', grid._pfmScr); } } catch (e) {}
    if (root) {
      var _scr = function () { if (!done && nearView()) pump(); };
      grid._pfmScr = _scr; grid._pfmScrRoot = root;
      root.addEventListener('scroll', _scr, { passive: true });
    }
    grid.appendChild(sent);
    io.observe(sent);
    pump();                                    /* 首屏先铺一批（不足一屏会自动续批至填满） */
  }
  function paint(){
    /* 2026-10-12（甲）：**单网格** —— 段只剩一个（标题 Library），#pfmLibOurs 即该网格。
       ⚠️ 兼容：即便 DOM 还是旧的（含 My Images 段）本函数照常工作（内容全进 Ours 网格）。
       🔴 绝不可再用 pfmLibMine* —— 元素已删，取不到会 return ⇒ 整块静默失效。 */
    var box=el('pfmLib'), gO=el('pfmLibOurs'), sO=el('pfmLibOursSec');
    if(!box||!gO) return;
    fill(gO, mine, ours);
    /* 标题常驻 —— 它是这个模块的「存在证明」，空库时也要看得见（上传口就在网格第一格）。 */
    if(sO) sO.style.display = '';
    var cO=el('pfmLibOursCnt');
    if(cO) cO.textContent = (mine.length+ours.length) ? String(mine.length+ours.length) : '';
    /* 2026-10-09（用户裁决①甲）：**空库也常驻可见**。
       原实现 `(mine.length||ours.length) ? '' : 'none'` 在空库时把整块（含标题、网格、
       空态文案）一起藏掉 ⇒ 用户「设计台没有看到素材库」（铁律：看不见的功能 = 不存在的功能）。 */
    box.style.display = '';
    /* 2026-10-08: 有内容就把「空库」提示撤掉 —— 否则刚上传完，屏幕上会同时出现
       「No assets yet. …」和已出现的缩略图（自相矛盾）。
       ingest() 成功后只走 paint()，清文案原本只写在 fetchList() 里，故补在这里。 */
    if(mine.length||ours.length) msg('');
  }
  function fetchList(){
    var id=ident();
    var u=B+'/assets/lib'+(id.email ? ('?email='+encodeURIComponent(id.email)+'&nickname='+encodeURIComponent(id.nick)) : '');
    return fetch(u,{headers:{'Accept':'application/json'}}).then(function(r){ return r.json(); }).then(function(d){
      if(!d||!d.success) throw new Error((d&&d.error)||'load failed');
      mine=(d.mine||[]); ours=(d.ours||[]);
      loaded=true; paint();
      msg((mine.length||ours.length) ? '' : 'No assets yet. Upload an image and it will be saved here.');
    });
  }
  function load(){
    if(loading) return Promise.resolve();
    loading=true; msg('Loading…');
    return fetchList().catch(function(e){
      msg('Could not load the library.'+((e&&e.message)?(' '+e.message):''));
    }).then(function(){ loading=false; });
  }
  /* 首次打开 Image 面板才拉数据（懒加载）；已加载过就不重复打网络 */
  function open(){ if(!loaded && !loading) return load(); return Promise.resolve(); }
  function refresh(){ loaded=false; return load(); }
  /* file → dataURL（必要时降采样）。PNG 保 PNG（留透明），JPG 走 JPEG q=0.88（先铺白底防透明区变黑）。 */
  function prep(file){
    return new Promise(function(resolve,reject){
      if(!/^image\/(png|jpe?g)$/.test(file.type)){ reject(new Error('Only PNG / JPG')); return; }
      var fr=new FileReader();
      fr.onerror=function(){ reject(new Error('read failed')); };
      fr.onload=function(){
        var url=String(fr.result||'');
        /* 🔴 2026-10-12（用户裁决）：**原图直传** —— 不做体积/尺寸限制，压缩交给后端 sharp
           （缩放质量更好；「上传中」用本地图先显示 ⇒ 慢也看不见）。
           仅当文件过大（> GUARD_BYTES）才降采样，避免请求体撑爆 50MB 上限。 */
        if(file.size<=GUARD_BYTES){ resolve(url); return; }
        var img=new Image();
        img.onerror=function(){ resolve(url); };      /* 解不开也别拦，交给后端判 */
        img.onload=function(){
          var long=Math.max(img.width,img.height)||1;
          var sc=Math.min(1,MAXEDGE/long);
          var w=Math.max(1,Math.round(img.width*sc)), h=Math.max(1,Math.round(img.height*sc));
          var cv=document.createElement('canvas'); cv.width=w; cv.height=h;
          var g=cv.getContext('2d');
          var isPng=/^image\/png$/.test(file.type);
          if(!isPng){ g.fillStyle='#ffffff'; g.fillRect(0,0,w,h); }
          g.drawImage(img,0,0,w,h);
          resolve(isPng ? cv.toDataURL('image/png') : cv.toDataURL('image/jpeg',0.88));
        };
        img.src=url;
      };
      fr.readAsDataURL(file);
    });
  }
  /* 上传原图 → My Images（fire-and-forget；失败只 toast，不影响画布）
     🔴 2026-10-12（用户报「画板立刻有图、素材库要等」）：**乐观占位** ——
        选完图先拿本地 objectURL 插一格（+ 号之后 = 个人素材第一位），上传成功**原地**
        换成服务器 item（位置不跳）、失败则撤掉。原来必须等 `prep`(压缩) + 跨洋上传
        **全部**返回才 `mine.unshift` ⇒ 库里空等；画板因本地 addImage 所以当场有图。 */
  function ingest(file){
    var id=ident();
    /* 🔴 2026-10-12（用户裁决 甲，不提示）：**无条件**先插本地预览格 ——
       「画板立刻有图、素材库却空白」的割裂对**没有身份**的用户同样成立
       （原实现 `if(!id.email) return` 直接**静默跳过** ⇒ 什么都不显示）。
       有身份 ⇒ 带"上传中"态（.pfm-pending + 转圈），上传成功后**原地**换真图；
       无身份 ⇒ 不上传、不转圈（`_local`）= 纯本地预览格（不提示、不落库、刷新即消失）。 */
    var hasId=!!id.email;
    var local='';
    try{ local=URL.createObjectURL(file); }catch(_){}
    var ghost={ url:local, thumb:local, _pending:hasId, _local:!hasId, w:0, h:0 };
    if(local){ mine.unshift(ghost); loaded=true; paint(); }   /* 立刻可见（零网络） */
    if(!hasId) return Promise.resolve();        /* 无身份 ⇒ 不入库（预览格已显示） */
    var settle=function(){ try{ if(local) URL.revokeObjectURL(local); }catch(_){} };
    var dropGhost=function(){ var i=mine.indexOf(ghost); if(i>=0) mine.splice(i,1); paint(); };
    return prep(file).then(function(dataUrl){
      return fetch(B+'/assets/lib/upload',{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({email:id.email,nickname:id.nick,dataUrl:dataUrl})});
    }).then(function(r){ return r.json(); }).then(function(d){
      if(!d||!d.success) throw new Error((d&&d.error)||'upload failed');
      var i=mine.indexOf(ghost);
      if(d.item && i>=0) mine.splice(i,1,d.item);   /* 原地换真图 ⇒ 位置不跳 */
      else if(d.item) mine.unshift(d.item);
      else if(i>=0) mine.splice(i,1);
      paint(); settle();
    }).catch(function(e){
      dropGhost(); settle();
      try{ showToast('⚠️ Could not add to My Images'+((e&&e.message)?(' — '+e.message):''),'warn'); }catch(_){}
    });
  }
  return { open:open, load:load, refresh:refresh, ingest:ingest,
           state:function(){ return { loaded:loaded, mine:mine.length, ours:ours.length }; } };
})();
